import React from 'react';
// import FormControl from '@material-ui/core/FormControl';
// import InputLabel from '@material-ui/core/InputLabel';
// import Select from '@material-ui/core/Select';
// import MenuItem from '@material-ui/core/MenuItem';
import ReactSelect from 'react-select'
import C18MuiFormControl from '../../usa/components/C18MuiFormControl'
import C18MuiInputLabel from '../../usa/components/C18MuiInputLabel'
import C18MuiSelect from '../../usa/components/C18MuiSelect'
import C18MuiMenuItem from '../../usa/components/C18MuiMenuItem'
import {cl,globs} from '../../components/utils/utils';
import {getParamId2} from '../../usa/utils/utils';
import {getZValue} from '../../components/utils/http';
import {pInd} from '../../components/utils/paramIds';

// Simple dotted compare: show Generic Sensor when fwVersion is above 1.18.30
// (e.g. 1.18.315). 1.18.30 and older stay hidden. isPearlFwAtLeast/calcFwVers
// ranks 1.18.315 below 1.18.4, so it cannot be used for this gate.
const MIN_GENERIC_SENSOR_FW = [1, 18, 30]

class FUISelect extends React.Component{
  constructor(props) {
    super(props);
//     cl(props)
    this.props.getValue(props.ind, {type: "scalar"})
    this.subscribe_updateFui=globs.events.subscribe("updateFui", this.updateFui)
//     cl("fui select get value")
  }

  // PID Analog Sensor (and any other FUISelect with genericSensorBase) is driven
  // by FUI page customProps, not PIDAdvancedSettings. Hide Generic Sensor on
  // firmware that does not support it. Fail closed when gateway/fw is unknown.
  supportsGenericSensor=()=>{
    let gwId=this.props.current?.gwId||this.props.zoneInfo?.gatewayId
    if(!gwId&&this.props.zuci){
      let z=+String(this.props.zuci).split("-")[0]
      let zone=globs.zonesInfo?.info?.find(zo=>zo.siteZoneIndex==z)
      gwId=zone?.gatewayId
    }
    const gateway=globs.gatewaysInfo?.info?.find(gw=>gw.gatewayId===gwId)
    if(!gateway?.fwVersion||gateway.gatewaySubType==="HydroR") return false
    const parts=String(gateway.fwVersion).split(".")
    if(parts.length<3) return false
    const major=parseInt(parts[0], 10)
    const minor=parseInt(parts[1], 10)
    const build=parseInt(parts[2], 10)
    if([major, minor, build].some(n=>Number.isNaN(n))) return false
    const [tMaj, tMin, tBld]=MIN_GENERIC_SENSOR_FW
    if(major!==tMaj) return major>tMaj
    if(minor!==tMin) return minor>tMin
    return build>tBld
  }

  getVisibleOptions=()=>{
    let options=this.props.custom?.options
    if(!options){return}
    let genBase=this.props.custom?.genericSensorBase
    let genMax=this.props.custom?.genericSensorMax
    if(genBase!=null&&genMax!=null&&!this.supportsGenericSensor()){
      return options.filter(c=>{
        let v=+c.v
        return isNaN(v)||v<genBase||v>genMax
      })
    }
    return options
  }

  makeInputMappingSelect=()=>{
    let options=this.getVisibleOptions()
    if(!options){
      cl("FUI Select Control is missing Options")
      return
    }
    return options.map((c, i)=>{
      return(
        <C18MuiMenuItem key={i} value={c.v}>{c.t}</C18MuiMenuItem>
      )
    });
  }

  onChange=(e)=>{
//     cl(e.target.value)
    this.props.onChange(this.props.ind, {value: e.target.value, e:e})
    this.changed=true// blocks updating
  }

    componentWillUnmount=()=>{
      this.subscribe_updateFui.remove()
//       this.subscribe_savePageEvent.remove()
    }

  updateFui=()=>{
//     cl("updateFui")
    if(!this.changed){this.props.getValue(this.props.ind, {type: "scalar"})}
  }

  // Generic Sensor support: when custom.genericSensorBase/genericSensorMax are
  // present, a value in that range is rendered as the "Generic Sensor" option
  // plus an adjacent searchable 1-N dropdown (index = value - (genericSensorBase - 1)).
  // Custom names are keyed like sensorNames ("e0gn<index0based>"). Callers that
  // already have them (e.g. PIDAdvancedSettings' override sensor) can pass
  // custom.genericSensorNames directly; otherwise we look them up here the same
  // way GenericSensors00.js does, using the zoneInfo LiveFui passes to every
  // control — this covers fields wired generically off backend customProps
  // (e.g. the main Sensor field), which never get genericSensorNames explicitly.
  getGenericSensorNames=()=>{
    if(this.props.custom?.genericSensorNames){return this.props.custom.genericSensorNames}
    let zoneInfo=this.props.zoneInfo
    if(!zoneInfo){return {}}
    let sensors=globs.sensorsInfo?.info?.find(s=>(s.siteId==zoneInfo.siteId)&&(s.zoneId==zoneInfo.zoneId))
    return sensors?.sensorNames||{}
  }

  // Only sensors mapped to a physical input (Sensor Mapping page or Auto Setup)
  // should be selectable. A custom name alone is not a mapping — that is why
  // "Custom 1" / "Custom 2" were appearing for unmapped slots.
  // pearl_gen_sens_conf.mapping: 0 = None, 29 = MBUS (the only mapped option
  // for generic sensors). Values are often stored as {val: n} objects; a raw
  // object is truthy even when val is 0, so we unwrap via getZValue.
  getMappedGenericSensorIndices=(genCount)=>{
    if(this.props.custom?.genericSensorMappedIndices){return this.props.custom.genericSensorMappedIndices}
    // zuci ("z-u-c-i") is passed by LiveFui to every control and is a plain
    // routing string — more reliably present than zoneInfo, which depends on
    // an array lookup that may not have resolved yet on first render.
    let z=this.props.zuci?.split("-")[0] ?? this.props.zoneInfo?.siteZoneIndex
    if(z==null||z===""){return null}// unknown zone context — don't filter
    let gwType=this.props.current?.gwType||1800
    let tab=pInd[gwType]?.pearl_gen_sens_conf
    if(!tab){return null}
    // Matches C18PearlMapping01: it always resolves this pid off gwType 1900.
    let mappingPid=+getParamId2(1900,"pearl_gen_sens_conf","mapping")
    let mult=tab[2]
    let mapped=new Set()
    for(let idx=0;idx<genCount;idx++){
      let mapping=+getZValue(+z,240,mappingPid+mult*idx)||0
      if(mapping){mapped.add(idx+1)}
    }
    return mapped
  }

  makeGenericSensorOptions=(genBase,genCount,currentVal,mapped)=>{
    let names=this.getGenericSensorNames()
    let currentN=currentVal!=null ? currentVal-(genBase-1) : null
    return [...Array(genCount)].map((a,idx)=>{
      let n=idx+1
      // Always keep the currently-selected sensor visible even if unmapped,
      // so an existing configuration never disappears from the dropdown.
      if(mapped && !mapped.has(n) && n!==currentN){return null}
      let custom=names[`e0gn${idx}`]
      return {value: (genBase-1)+n, label: custom || `Generic Sensor ${n}`}
    }).filter(Boolean)
  }

  onGenericSensorSelectChange=(option)=>{
    if(!option){return}
    this.changed=true
    this.props.onChange(this.props.ind, {value: option.value, e:{target:{value:option.value}, currentTarget:{value:option.value}}})
  }

  render(){
//     cl(this.props)
//     if(this.props.ind==5){cl(this.props)}
//     cl(this.props.ind,this.props.value)

    let val=this.props.value
    if(val===true){val=1}// temp!! to handle the 'true' valuse from 800
    if(val!=null && typeof val==="object" && !Array.isArray(val)){val=val.val}
//     if(this.props.ind==7){cl(val)}
    if(Array.isArray(val)){val=0}
    if(this.props.custom?.options?.length && typeof this.props.custom.options[0].v==="number"){
      if(val!=null && val!==""){val=+val}
    }
    let genBase=this.props.custom?.genericSensorBase
    let genMax=this.props.custom?.genericSensorMax
    if(!this.supportsGenericSensor()){
      genBase=undefined
      genMax=undefined
    }
    let genCount=this.props.custom?.genericSensorCount || (genBase!=null && genMax!=null ? (genMax-genBase+1) : 0)
    let hasGenericSensor=genBase!=null && genMax!=null
    let inGenericRange=hasGenericSensor && val!=null && val!=="" && !isNaN(+val) && (+val)>=genBase && (+val)<=genMax
    let selectVal=inGenericRange ? genBase : val
    // Inline reuse via showFUISelect has no cont.title. Skip the empty label and
    // extra top margin so the select lines up with sibling inputs in a flex row.
    let mainHasLabel=!!this.props.cont.title
    let style={}
    let style2={minWidth: 150}
    if(mainHasLabel){style2.marginTop=22}
    if(this.props.cont.width){
      style.width=this.props.cont.width
      style2.minWidth=this.props.cont.width
    }
    if(this.props.cont.inline){
      style.display="inline"
    }
    // Side-by-side Generic Sensor index: drop the select's extra bottom margin so
    // the two labeled stacks share one baseline. Unlabeled (OVERRIDE) stays compact.
    let selectBreak=this.props.custom?.break ?? ((mainHasLabel && !inGenericRange) ? undefined : "none")
//     cl(this.props.cont.title)
    let mapped=inGenericRange ? this.getMappedGenericSensorIndices(genCount) : null
    // Nothing mapped yet (as opposed to "unknown" — mapped is null there):
    // point the user at Sensor Mapping instead of offering an empty-feeling list.
    let noSensorsMapped=inGenericRange && mapped && mapped.size===0
    let genericSensorOptions=(inGenericRange && !noSensorsMapped) ? this.makeGenericSensorOptions(genBase,genCount,+val,mapped) : []
    let genericIndexInput=(
      <span className={"fui-generic-sensor-index" + (mainHasLabel ? " labeled" : " inline") + (noSensorsMapped && mainHasLabel ? " unmapped" : "")}>
        {noSensorsMapped ? (
          <span className="fui-generic-sensor-unmapped-msg">Map the Generic Sensor first to view available options.</span>
        ) : (
          <ReactSelect
            value={genericSensorOptions.find(o=>o.value===+val) || null}
            options={genericSensorOptions}
            onChange={this.onGenericSensorSelectChange}
            isSearchable={true}
            isClearable={false}
            maxMenuHeight={320}
            menuPortalTarget={document.body}
            placeholder="Search..."
            styles={{
              // Keep this compact so the OVERRIDE sentence can wrap instead of
              // overflowing when the content area is narrower than the window
              // (e.g. with the right sidebar open).
              container: base=>({...base, width:150, minWidth:120, maxWidth:"100%", flexShrink:1, display:"inline-block"}),
              menuPortal: base=>({...base, zIndex:9999}),
              singleValue: base=>({...base, overflow:"hidden", textOverflow:"ellipsis"}),
            }}
          />
        )}
      </span>
    )
    let pairStyle=(!mainHasLabel || hasGenericSensor) ? {
      display:"inline-flex",
      alignItems: mainHasLabel ? "flex-start" : "center",
      flexWrap: "wrap",
      gap: 8,
      maxWidth: "100%",
    } : undefined
    return(
      <div id={this.props?.custom?.infoId} className={mainHasLabel && inGenericRange ? "fui-generic-sensor-pair" : undefined} style={pairStyle}>
        <C18MuiFormControl
        style={style2}
        title={(this.props?.rest?.parent||(e=>{}))({uri:"pid",pr:this.props})}
        >
          {mainHasLabel &&
            <C18MuiInputLabel>{this.props.cont.title}</C18MuiInputLabel>
          }
          <C18MuiSelect
            value={selectVal}
            title={(this.props?.rest?.parent||(e=>{}))({uri:"pid",pr:this.props})}
            onChange={this.onChange}
            saveOK={this.props.saveOK}
            break={selectBreak}
            >
            {this.makeInputMappingSelect()}
          </C18MuiSelect>
        </C18MuiFormControl>
        {inGenericRange && (mainHasLabel ?
          <C18MuiFormControl style={{minWidth: noSensorsMapped ? 220 : 80, marginTop: style2.marginTop || 0}}>
            {/* Empty label keeps the hint on the select row without showing 1-N */}
            <C18MuiInputLabel>{noSensorsMapped ? "\u00a0" : `Generic Sensor 1-${genCount}`}</C18MuiInputLabel>
            {genericIndexInput}
          </C18MuiFormControl>
          :
          genericIndexInput
        )}
      </div>
    );
  }

}


  export default FUISelect ;
